<template>
  <page-view title="发送记录">
    <a-card>
      <a-form :form="form">
        <table class="fx-form">
          <tr>
            <th>号码</th>
            <td>
              <a-form-item>
                <a-input style="width: 300px" v-model="queryForm.mobile"></a-input>
              </a-form-item>
            </td>
            <th>内容</th>
            <td>
              <a-form-item>
                <a-input style="width: 300px" v-model="queryForm.content"></a-input>
              </a-form-item>
            </td>
          </tr>
          <tr>
            <th>发送时间</th>
            <td>
              <a-form-item>
                <a-date-picker v-model="queryForm.startDate" /> 至 <a-date-picker v-model="queryForm.endDate" />
              </a-form-item>
            </td>
            <th>状态</th>
            <td>
              <a-form-item>
                <a-select style="width: 170px" v-model="queryForm.state" allowClear>
                  <a-select-option value="S">成功</a-select-option>
                  <a-select-option value="F">失败</a-select-option>
                </a-select>
              </a-form-item>
            </td>
          </tr>
          <tr>
            <td colspan="4" align="center" style="padding:14px 0">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button @click="reset">重置</a-button>
            </td>
          </tr>
        </table>
      </a-form>
      <s-table
          ref="table"
          :columns="columns"
          :data="loadData"
          :rowKey="record => record.id">
        <template slot="mobile" slot-scope="record">
          <a @click="showDetailModal(record)"><span v-html="$helper.nl2br(record.extras.mobile)"></span></a>
        </template>
        <template slot="content" slot-scope="record">
          {{record.content}}
        </template>
        <template slot="createdAt" slot-scope="record">
          {{record.createdAt}}
        </template>
        <template slot="state" slot-scope="record">
          <a-tag v-if="record.result === 'S'" color="green">发送成功</a-tag>
          <a-tag v-else color="red">失败</a-tag>
        </template>
        <template slot="vendor" slot-scope="record">
          {{record.vendor}}
        </template>
      </s-table>
    </a-card>
    <a-modal title="详细信息" v-model="showSmsDetail" :width="960" @ok="onCloseDetail">
      <div>
        <table class="fx-form-view">
          <tr>
            <th>接收号码</th>
            <td colspan="3">
              {{ smsDetailMobile }}
            </td>
          </tr>
          <tr>
            <th>内容</th>
            <td colspan="3">
              {{ smsRecord.content }}
            </td>
          </tr>
          <tr>
            <th>发送时间</th>
            <td>
              {{ smsRecord.createdAt }}
            </td>
            <th>状态</th>
            <td>
              {{ smsRecord.result === 'S' ? '成功' : '失败' }}
            </td>
          </tr>
          <tr>
            <th>短信提供商</th>
            <td colspan="3">
              {{ smsRecord.vendor }}
            </td>
          </tr>
          <tr>
            <th>服务商响应</th>
            <td colspan="3">
              <div class="response-content">
                {{ smsRecord.response }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </a-modal>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import qs from 'qs'

export default {
  name: 'SmsIndex',
  components: {
    PageView,
    STable
  },
  created () {
  },
  data () {
    return {
      showSmsDetail: false,
      smsDetailMobile: null,
      columns: [
        {
          title: '发送号码',
          scopedSlots: { customRender: 'mobile' },
          width: '255px'
        },
        {
          title: '内容',
          scopedSlots: { customRender: 'content' }
        },
        {
          title: '发送时间',
          scopedSlots: { customRender: 'createdAt' },
          width: '180px'
        },
        {
          title: '发送状态',
          scopedSlots: { customRender: 'state' },
          width: '120px'
        },
        {
          title: '短信提供商',
          scopedSlots: { customRender: 'vendor' },
          width: '150px'
        }
      ],
      loading: false,
      form: this.$form.createForm(this),
      queryForm: {
        state: null,
        query: '',
        startDate: null,
        endDate: null
      },
      smsRecord: {
      },
      queryParam: {
      },
      loadData: parameter => {
        return this.$http.get('/api/1/sms/query_sms_list.json', { params: Object.assign(parameter, this.queryParam),
          paramsSerializer: function (params) {
            return qs.stringify(params, { indices: false })
          }
        }).then(res => {
          return res
        })
      }
    }
  },
  methods: {
    showDetailModal (record) {
      this.showSmsDetail = true
      this.smsRecord = record
      this.getSmsDetailMobile(record)
    },
    getSmsDetailMobile (record) {
      const that = this
      that.$http.get('/api/1/sms/get_sms_mobile_list.json?recordId=' + record.id).then(function (resp) {
        that.smsDetailMobile = resp.msg
      })
    },
    onCloseDetail () {
      this.showSmsDetail = false
    },
    reset () {
      this.queryForm = {}
      this.queryParam = {}
      this.onSearch()
    },
    onSearch () {
      this.queryParam = { ...this.queryForm }
      if (this.queryParam.startDate) {
        this.queryParam.startDate = this.queryParam.startDate.format('YYYY-MM-DD')
      }
      if (this.queryParam.endDate) {
        this.queryParam.endDate = this.queryParam.endDate.format('YYYY-MM-DD')
      }
      this.$refs.table.refresh()
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 24px;
}

th {
  width: 110px !important;
}

table .ant-form-item {
  margin-bottom: 0;
}

.response-content {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: auto;
  word-wrap: break-word;
  word-break: break-all;
}
</style>
